import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { HandlerBase } from "./HandlerBase";
import { resetDragCursor, setDragCursor } from "./helpers";
export var DragSourceHandler = /*#__PURE__*/function (_HandlerBase) {
  _inherits(DragSourceHandler, _HandlerBase);
  var _super = _createSuper(DragSourceHandler);
  function DragSourceHandler() {
    var _thisSuper, _this;
    _classCallCheck(this, DragSourceHandler);
    for (var _len = arguments.length, _args2 = new Array(_len), _key = 0; _key < _len; _key++) {
      _args2[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args2));
    _defineProperty(_assertThisInitialized(_this), "attachHandlers", function (domNode) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this.registerHandler([domNode].concat(args), 'mousedown', _this.handleDragMouseDown.bind(_assertThisInitialized(_this)));
    });
    _defineProperty(_assertThisInitialized(_this), "detachHandlers", function (domNode) {
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(DragSourceHandler.prototype)), "detachHandlers", _thisSuper).call(_thisSuper, domNode);
    });
    return _this;
  }
  _createClass(DragSourceHandler, [{
    key: "handleDragMouseDown",
    value: function handleDragMouseDown(event) {
      var handleStart = this.handleDragStart;
      var handleEnd = this.handleDragEnd;
      document.addEventListener('mousemove', handleStart);
      document.addEventListener('mouseup', handleEnd);
      event.stopPropagation();
      event.preventDefault();
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      document.removeEventListener('mousemove', this.handleDragStart);
      setDragCursor();
      event.stopPropagation();
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd(_event) {
      resetDragCursor();
      document.removeEventListener('mouseup', this.handleDragEnd);
      document.removeEventListener('mousemove', this.handleDragStart);
    }
  }]);
  return DragSourceHandler;
}(HandlerBase);